var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2003_565",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H14V14H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2003_565)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0851 3.4458L11.5273 4.98482L9.0968 2.46382L10.6152 0.950429L13.0851 3.4458ZM10.9012 5.61581L5.08286 11.4239C4.9113 11.5885 4.73185 11.7019 4.54648 11.7621L0.996935 13.0014L2.30435 9.42936C2.38224 9.21739 2.49958 9.03401 2.6455 8.89401L8.4638 3.0958L10.9012 5.61581ZM13.7911 2.96565L11.1447 0.222818C11.0017 0.0769019 10.8213 0 10.6241 0C10.421 0 10.2287 0.0778879 10.0946 0.213945L2.02137 8.26104C1.78079 8.49668 1.58951 8.79541 1.46922 9.12373L0.0464458 12.9984C-0.0521527 13.2685 0.00799239 13.5663 0.210119 13.7793C0.359989 13.9222 0.547326 14.0001 0.737621 14.0001C0.793822 14.0001 0.854953 13.9902 0.910169 13.9824L4.83537 12.6159C5.1499 12.5094 5.45063 12.323 5.70699 12.0746L13.7812 4.02552C13.9252 3.88059 14.0001 3.69819 14.0001 3.49904C14.0001 3.292 13.9262 3.10171 13.7911 2.96565Z",
    fill: "#291482"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e1f79856774dfcfaff18e5d900e5cf75.svg";
export { ForwardRef as ReactComponent };